import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import FieldIconWrapper from 'common/components/form/FieldIconWrapper';

const FieldTextArea = ({
  rows = 3,
  name = '',
  value = '',
  className = '',
  placeholder,
  autoFocus,
  inputSize,
  handleChange = () => {},
  maxLength,
  ...passThroughProps
}) => (
  <FieldIconWrapper {...passThroughProps}>
    <textarea
      className={classnames(
        'form-control',
        {
          [`form-control-${inputSize}`]: !!inputSize,
          'is-invalid': passThroughProps.error && Object.keys(passThroughProps.error).length > 0,
        },
        className
      )}
      name={name}
      rows={rows}
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      autoFocus={autoFocus}
      maxLength={maxLength}
    />
  </FieldIconWrapper>
);

FieldTextArea.propTypes = {
  rows: PropTypes.number,
  maxLength: PropTypes.number,
  value: PropTypes.any,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  autoFocus: PropTypes.bool,
  error: PropTypes.object,
  handleChange: PropTypes.func,
  inputSize: PropTypes.oneOf(['lg', 'sm']),
  iconRight: PropTypes.string,
  iconLeft: PropTypes.string,
  iconRightSize: PropTypes.oneOf(['lg', '2x', '3x', '4x', '5x']),
  iconRightSpin: PropTypes.bool,
  iconLeftSize: PropTypes.oneOf(['lg', '2x', '3x', '4x', '5x']),
  iconLeftSpin: PropTypes.bool,
};

export default FieldTextArea;



// WEBPACK FOOTER //
// src/modules/common/components/form/FieldTextArea.js